import { IconVariants } from "@next-platform/client-common-spicy-ui";

export function getVoicePreviewButtonIcon(isLoading: boolean, isPlaying: boolean): IconVariants | undefined {
  if (isLoading) return undefined;
  return isPlaying ? IconVariants.PAUSE : IconVariants.PLAY;
}

export function getVoicePreviewButtonLabel(isLoading: boolean, isPlaying: boolean): string {
  if (isLoading) return "generating";
  return isPlaying ? "stopPreview" : "playPreview";
}

export function getVoicePreviewButtonText(isLoading: boolean, isPlaying: boolean): string {
  if (isLoading) return "generating";
  return isPlaying ? "stop" : "speak";
}
